module.exports = __webpack_public_path__ + "static/media/revert-changes.0462b415.svg";